import React, { useState } from "react"
import Card from "components/Card/Card"
import { Row } from "react-bootstrap"
import { Col } from "react-bootstrap"
import { Typography, useMediaQuery, Checkbox } from "@mui/material"
import trashIcon from "assets/icons/trash.svg"
import { useTheme } from "@mui/system"
import { useDispatch } from "react-redux"
import { marketingActions } from "redux/marketing/slice/user"
import DeleteConfirmationDialog from "components/DeleteConfirmationDialog"
import { getBarItemsAction } from "redux/marketing/actions"
import ImageDisplay from "components/ImageDisplayer"
import classes from "pages/private/marketing/menu/menu.module.scss"
import Paragraph from "components/ReadMoreParagraph"
import {
  DeleteBarMenuCategoryAction,
  deleteBarItemAction,
  updateBarItemsAction
} from "redux/marketing/actions/user"
import editIcon from "assets/icons/edit.svg"
import AddMenuItemButton from "components/StyledComponents/addNewItemButton"
import { formatMenuDate } from "helpers/functions"
import MenuAction from "components/MenuAction"
import { Droppable, Draggable } from "react-beautiful-dnd"
import DragIndicatorIcon from "@mui/icons-material/DragIndicator"

function BarListItems({
  data,
  isEdit = false,
  isReviewMode = false,
  selectedItems = [],
  handleToggleItem = () => {},
  setCategoryModal = () => {},
  setIsEdit = () => {},
  setIsEditModalItem = () => {},
  setCurrentCategoryData = () => {},
  setMenuItemsModal = () => {},
  setOpenPreviewModal = () => {},
  droppableId,
  dragEnabled = false
}) {
  const theme = useTheme()
  const [modal, setDeleteModal] = useState(false)
  const [modalItem, setDeleteItemModal] = useState(false)
  const [ArchiveModal, setArchiveItemModal] = useState(false)
  const [menuState, setMenuState] = useState({
    anchorEl: null,
    item: null,
    category: null
  })

  const dispatch = useDispatch()
  const categoryLength = data?.food_category?.length || 0
  const isSmall = useMediaQuery("(max-width:1440px)")
  const isDraggable =
    !isReviewMode &&
    !!droppableId &&
    dragEnabled &&
    (data?.food_list || []).every((it) => it?.id != null)

  const handleClick = (type, id, data, item) => {
    dispatch(marketingActions.setMenuItemId(id))
    dispatch(marketingActions.setBarCategory(data?.food_category))
    dispatch(marketingActions.setMenuCategoryId(data?.food_category_id))
    dispatch(marketingActions.setMenuPreviewData(item))
    dispatch(getBarItemsAction())
    if (type == "edit") {
      handleEditMenuItemModal()
    } else if (type == "archive") {
      handleArchiveItem()
    } else if (type == "preview") {
      setOpenPreviewModal(true)
    } else {
      handleMenuItemDeleteModal()
    }
    setMenuState((prev) => ({
      ...prev,
      anchorEl: null
    }))
  }

  function EditCategoryModal(id) {
    dispatch(marketingActions.setMenuCategoryId(id))
    setCategoryModal(true)
    setIsEdit(true)
    setCurrentCategoryData(data)
  }

  function handleMenuPeriodDelete(id) {
    dispatch(marketingActions.setMenuCategoryId(id))
    dispatch(DeleteBarMenuCategoryAction({ mealCategoryId: id }))
  }

  function handleMenuDeleteModal(id) {
    dispatch(marketingActions.setMenuCategoryId(id))
    setDeleteModal(true)
  }
  function handleMenuItemDeleteModal() {
    setDeleteItemModal(true)
  }

  function handleEditMenuItemModal() {
    setIsEditModalItem(true)
    setMenuItemsModal(true)
  }

  function handleMenuItemDelete() {
    dispatch(deleteBarItemAction({ pending_review: isReviewMode }))
  }

  function handleCloseModal() {
    setDeleteItemModal(false)
    dispatch(marketingActions.setMenuItemId(""))
  }

  function handleArchiveItem() {
    setArchiveItemModal(true)
  }

  function handleCloseArchiveModal() {
    setArchiveItemModal(false)
  }

  function handleArchiveMenuItem() {
    const payload = {
      item_state: "archived"
    }
    dispatch(updateBarItemsAction({ payload: payload, onClose: handleCloseArchiveModal }))
  }

  function handleAddItems(id, data) {
    dispatch(marketingActions.setBarCategory(data?.food_category))
    setIsEditModalItem(false)
    dispatch(marketingActions.setMenuCategoryId(id))
    setMenuItemsModal(true)
    dispatch(marketingActions.setFoodItemsDetail({}))
  }

  const handleMenuClick = (event, item, category) => {
    setMenuState({
      anchorEl: event.currentTarget,
      item,
      category
    })
  }

  const handleClose = () => {
    setMenuState({
      anchorEl: null,
      item: null,
      category: null
    })
  }

  return (
    <>
      <DeleteConfirmationDialog
        title={`Are you sure you want to delete “${data?.food_category ?? ""}”?`}
        description={`"${data?.food_category ?? ""}" has ${data?.food_list?.length ?? ""} ${
          data?.food_list?.length <= 1 ? "dish" : "dishes"
        }`}
        style={{ textAlign: "center", width: "80%" }}
        onClose={() => setDeleteModal(false)}
        onDelete={() => handleMenuPeriodDelete(data?.food_category_id)}
        open={modal}></DeleteConfirmationDialog>
      <DeleteConfirmationDialog
        title={`Are you sure you want to delete this bar item ?`}
        description={" "}
        style={{ textAlign: "center" }}
        onClose={handleCloseModal}
        onDelete={() => handleMenuItemDelete()}
        open={modalItem}></DeleteConfirmationDialog>
      <DeleteConfirmationDialog
        title={`Are you sure you want to archive this bar item?`}
        description={" "}
        style={{ textAlign: "center" }}
        onClose={handleCloseArchiveModal}
        onDelete={() => handleArchiveMenuItem()}
        open={ArchiveModal}
        btnText="Archive"
        type="warning"
      />
      <Card style={{ height: "fit-content" }}>
        <Row>
          <Col lg="12">
            <div
              className="d-flex justify-content-between align-item-center"
              style={{
                backgroundColor: isEdit && theme.palette.background.default,
                padding: ` ${isEdit ? "12px 16px" : "0px"}`,
                borderRadius: 6
              }}>
              <div className="d-flex positon-absolute">
                <Typography variant="h2">
                  {data?.food_category}
                  {isEdit && !isReviewMode && (
                    <img
                      className={classes.edit}
                      src={editIcon}
                      onClick={() => EditCategoryModal(data?.food_category_id)}
                    />
                  )}
                </Typography>
              </div>
              {isEdit && !isReviewMode && (
                <div className="d-flex align-items-center">
                  <AddMenuItemButton
                    onAddItems={() => handleAddItems(data?.food_category_id, data)}
                    text="Add Menu Item"
                    typographyClass={classes.addButton}
                    {...(isSmall && categoryLength > 23 ? { isLongCategory: true } : {})}
                  />
                  <img
                    className={classes.trashIcon}
                    onClick={() => handleMenuDeleteModal(data?.food_category_id)}
                    src={trashIcon}
                    alt=""
                  />
                </div>
              )}
            </div>
          </Col>
          <Col lg="12">
            {(() => {
              const renderItemRow = (item, idx, dragProvided, dragSnapshot) => (
                <div
                  ref={dragProvided?.innerRef}
                  {...(dragProvided?.draggableProps || {})}
                  onDoubleClick={() => !isReviewMode && handleClick("edit", item?.id, data)}
                  title={isReviewMode ? undefined : "Double-click to edit"}
                  style={{
                    ...(dragProvided?.draggableProps?.style || {}),
                    border: `${isEdit ? `1px solid ${theme.palette.secondary.main}` : "none"}`,
                    borderBottom: `${
                      !isEdit ? `1px solid #605e5e` : `.5px solid ${theme.palette.secondary.main}`
                    }`,
                    borderRadius: `${isEdit ? "6px" : "0px"}`,
                    padding: `${isEdit ? "8px" : "5px"}`,
                    margin: "24px 0",
                    opacity: isReviewMode ? (selectedItems.includes(item?.id) ? 1 : 0.5) : 1,
                    backgroundColor: dragSnapshot?.isDragging
                      ? theme.palette.background.default
                      : undefined
                  }}>
                  <div
                    className={
                      isReviewMode ? `${classes.reviewItemContainer}` : `${classes.itemContainer}`
                    }
                    style={{
                      margin: "0",
                      ...(isDraggable ? { gridTemplateColumns: "auto 1fr 1.9fr 0.1fr" } : {})
                    }}>
                    {isDraggable && (
                      <span
                        {...(dragProvided?.dragHandleProps || {})}
                        aria-label="Drag to reorder or move item"
                        style={{
                          cursor: dragSnapshot?.isDragging ? "grabbing" : "grab",
                          display: "inline-flex",
                          // alignItems: "center",
                          userSelect: "none",
                          marginRight: 8
                        }}>
                        <DragIndicatorIcon sx={{ color: theme.palette.text.secondary }} />
                      </span>
                    )}
                    {isReviewMode && (
                      <div className="d-flex align-items-center">
                        <Checkbox
                          sx={{
                            color: theme.palette.secondary.main,
                            "&.Mui-checked": {
                              color: theme.palette.secondary.main
                            }
                          }}
                          checked={selectedItems.includes(item?.id)}
                          onChange={() => handleToggleItem(item?.id)}
                        />
                      </div>
                    )}
                    <div className={classes.imageContainer} style={{ height: 250 }}>
                      <ImageDisplay data={item?.image_url}></ImageDisplay>
                    </div>
                    <div
                      style={{
                        justifyContent: "center",
                        flexDirection: "column",
                        maxWidth: 375,
                        overflowWrap: "break-word"
                      }}>
                      <div>
                        <Typography variant="h4">{item?.name ?? "-"}</Typography>
                      </div>
                      <div>
                        {item?.data_to_display?.map((data, index) => {
                          return (
                            <div key={index}>
                              {data.filedName === "Ingredients"
                                ? (data?.value?.length > 0 || isEdit) && (
                                    <div className="mt-2">
                                      <Typography variant="tag1">{data.filedName}</Typography>
                                      <br></br>

                                      {typeof data?.value !== "string" ? (
                                        data?.value?.map((item, index) => (
                                          <Typography
                                            key={index}
                                            sx={{
                                              opacity: 0.6,
                                              fontSize: 12,
                                              fontWeight: "400",
                                              fontStyle: "italic",
                                              display: item?.name ? "list-item" : "",
                                              marginLeft: 2
                                            }}>
                                            {`${item?.name ?? ""}`}
                                            {item?.measurement
                                              ? data?.value?.length - 1 > index
                                                ? ` (${item?.measurement})`
                                                : item?.measurement
                                                ? ` (${item?.measurement}) `
                                                : ""
                                              : data?.value?.length - 1 > index
                                              ? ", "
                                              : ""}
                                          </Typography>
                                        ))
                                      ) : (
                                        <div>
                                          {data.value.split(",").map((ingredient, index) => (
                                            <Typography
                                              key={index}
                                              sx={{
                                                opacity: 0.6,
                                                fontSize: 12,
                                                fontWeight: "400",
                                                fontStyle: "italic",
                                                display: ingredient ? "list-item" : "",
                                                marginLeft: 2
                                              }}>
                                              {data.value.split(",")?.length - 1 > index
                                                ? `${ingredient.trim()},`
                                                : ingredient.trim()}
                                            </Typography>
                                          ))}
                                        </div>
                                      )}
                                    </div>
                                  )
                                : data.filedName === "Ice"
                                ? (data?.value?.length > 0 || isEdit) && (
                                    <div className="mt-2">
                                      <Typography sx={{ fontSize: 12, fontWeight: "400" }}>
                                        {"Ice"}
                                      </Typography>
                                      <Typography
                                        sx={{
                                          opacity: 0.6,
                                          fontSize: 12,
                                          fontWeight: "400",
                                          fontStyle: "italic"
                                        }}>
                                        {data?.value?.map((allergance, index) => {
                                          return (
                                            allergance?.name +
                                              (data?.value?.length - 1 > index ? ", " : "") ?? "-"
                                          )
                                        })}
                                      </Typography>
                                    </div>
                                  )
                                : data.filedName === "Unique Facts"
                                ? (data?.value?.length || isEdit) && (
                                    <div className="mt-2">
                                      <Typography variant="tag1">{data.filedName}</Typography>
                                      <br></br>
                                      {data?.value?.length === 1
                                        ? data?.value?.map((item, index) =>
                                            item?.fact !== "" ? (
                                              <Typography
                                                component="div"
                                                style={{
                                                  display: item?.fact ? "list-item" : "",
                                                  marginLeft: 15
                                                }}
                                                key={index}
                                                variant="tagItalic"
                                                sx={{ opacity: 0.6 }}>
                                                <Paragraph
                                                  text={item?.fact ?? ""}
                                                  maxCharCount={70}
                                                  key={index}
                                                  variant="tagItalic"
                                                  sx={{ opacity: 0.6 }}></Paragraph>
                                              </Typography>
                                            ) : null
                                          )
                                        : data?.value?.map((item, index) => (
                                            <Typography
                                              component="div"
                                              style={{
                                                display: item?.fact ? "list-item" : "",
                                                marginLeft: 15
                                              }}
                                              key={index}
                                              variant="tagItalic"
                                              sx={{ opacity: 0.6 }}>
                                              <Paragraph
                                                text={item?.fact ?? ""}
                                                maxCharCount={70}
                                                key={index}
                                                variant="tagItalic"
                                                sx={{ opacity: 0.6 }}></Paragraph>
                                            </Typography>
                                          ))}
                                    </div>
                                  )
                                : data.filedName === "Tasting Notes"
                                ? (data?.value?.length > 0 || isEdit) && (
                                    <div className="mt-2">
                                      <Typography sx={{ fontSize: 12, fontWeight: "400" }}>
                                        {data.filedName}
                                      </Typography>
                                      <Typography
                                        sx={{
                                          opacity: 0.6,
                                          fontSize: 12,
                                          fontWeight: "400",
                                          fontStyle: "italic"
                                        }}>
                                        {data?.value?.length > 0
                                          ? data?.value?.map((notes, index) => {
                                              return data?.value?.length - 1 > index
                                                ? `${notes?.name}, `
                                                : `${notes?.name}`
                                            })
                                          : ""}
                                      </Typography>
                                    </div>
                                  )
                                : data.filedName === "Allergens"
                                ? (data?.value?.length > 0 || isEdit) && (
                                    <div className="mt-2">
                                      <Typography sx={{ fontSize: 12, fontWeight: "400" }}>
                                        {data.filedName}
                                      </Typography>
                                      <Typography
                                        sx={{
                                          opacity: 0.6,
                                          fontSize: 12,
                                          fontWeight: "400",
                                          fontStyle: "italic"
                                        }}>
                                        {data?.value?.length > 0
                                          ? data?.value?.map((item, index) => {
                                              return data?.value?.length - 1 > index
                                                ? `${item}, `
                                                : `${item}`
                                            })
                                          : ""}
                                      </Typography>
                                    </div>
                                  )
                                : (data?.value || isEdit) && (
                                    <div className="mt-2">
                                      <Typography sx={{ fontSize: 12, fontWeight: "400" }}>
                                        {data.filedName}
                                      </Typography>
                                      <Typography
                                        component="div"
                                        sx={{
                                          opacity: 0.6,
                                          fontSize: 12,
                                          fontWeight: "400",
                                          fontStyle: "italic"
                                        }}>
                                        {typeof data?.value === "string" &&
                                        data.value.includes("\n") ? (
                                          data.value
                                            .split("\n")
                                            .map((line, index) =>
                                              line.length > 70 ? (
                                                <Paragraph
                                                  key={index}
                                                  text={line}
                                                  maxCharCount={70}
                                                />
                                              ) : (
                                                <div key={index}>{line}</div>
                                              )
                                            )
                                        ) : typeof data?.value === "string" &&
                                          data.value.length > 70 ? (
                                          <Paragraph text={data.value} maxCharCount={70} />
                                        ) : (
                                          data?.value || "-"
                                        )}
                                      </Typography>
                                    </div>
                                  )}
                            </div>
                          )
                        })}
                      </div>
                    </div>
                    <div className="d-flex justify-content-between">
                      <div>
                        {item?.price > 0 && <Typography variant="bold">${item?.price}</Typography>}
                      </div>
                      {isEdit && (
                        <MenuAction
                          open={Boolean(menuState.anchorEl) && menuState.item?.id === item?.id}
                          anchorEl={menuState.anchorEl}
                          handleMenuClick={(e) => handleMenuClick(e, item, data)}
                          handleClose={handleClose}
                          handleClick={(type) => handleClick(type, item?.id, data, item)}
                          itemId={item?.id}
                          categoryIdData={data}
                          item={item}
                          isReviewMode={isReviewMode}
                        />
                      )}
                    </div>
                  </div>
                  <div className="d-flex flex-column justify-content-end align-items-end">
                    <div>
                      <Typography
                        component="div"
                        sx={{
                          fontSize: 14,
                          fontWeight: "400"
                        }}>
                        Added:{" "}
                        <Typography
                          sx={(theme) => ({
                            fontSize: 14,
                            fontWeight: "400",
                            color: theme.palette.orange.tertiary,
                            cursor: "pointer"
                          })}
                          variant="tag1">
                          {formatMenuDate(item?.created_at)}
                        </Typography>
                      </Typography>
                    </div>
                    {item?.updated_at ? (
                      <div>
                        <Typography
                          component="div"
                          sx={{
                            fontSize: 14,
                            fontWeight: "400"
                          }}>
                          Updated:{" "}
                          <Typography
                            sx={(theme) => ({
                              fontSize: 14,
                              fontWeight: "400",
                              color: theme.palette.orange.tertiary,
                              cursor: "pointer"
                            })}
                            variant="tag1">
                            {formatMenuDate(item?.updated_at)}
                          </Typography>
                        </Typography>
                      </div>
                    ) : null}
                  </div>
                </div>
              )

              const itemList = data?.food_list?.length ? (
                data?.food_list?.map((item, idx) =>
                  isDraggable ? (
                    <Draggable key={item?.id ?? idx} draggableId={String(item?.id)} index={idx}>
                      {(provided, snapshot) => renderItemRow(item, idx, provided, snapshot)}
                    </Draggable>
                  ) : (
                    <React.Fragment key={idx}>{renderItemRow(item, idx)}</React.Fragment>
                  )
                )
              ) : (
                <Typography className="mt-4" style={{ opacity: 0.6, textAlign: "center" }}>
                  No Items Found
                </Typography>
              )

              return isDraggable ? (
                <Droppable droppableId={droppableId}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      style={{
                        minHeight: 40,
                        borderRadius: 6,
                        backgroundColor: snapshot.isDraggingOver
                          ? theme.palette.background.default
                          : "transparent",
                        transition: "background-color 120ms ease"
                      }}>
                      {itemList}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              ) : (
                itemList
              )
            })()}
          </Col>
        </Row>
      </Card>
    </>
  )
}

export default React.memo(BarListItems)
